export default {
  "mainVegetable": "darzoves",
  "mainVegetable/01": "darzoves/baklazanas",
  "mainVegetable/02": "darzoves/smidras",
  "mainVegetable/03": "darzoves/avokadas",
  "mainVegetable/04": "darzoves/burokelis",
  "mainVegetable/05": "darzoves/brokolis",
  "mainVegetable/06": "darzoves/morka",
  "mainVegetable/07": "darzoves/salieras",
  "mainVegetable/08": "darzoves/pievagrybiai",
  "mainVegetable/09": "darzoves/kopustas",
  "mainVegetable/10": "darzoves/briuselio-kopustas",
  "mainVegetable/11": "darzoves/pekino-kopustas",
  "mainVegetable/12": "darzoves/ziedinis-kopustas",
  "mainVegetable/13": "darzoves/coleslaw",
  "mainVegetable/14": "darzoves/agurkas",
  "mainVegetable/15": "darzoves/cukinija",
  "mainVegetable/16": "darzoves/garbanotoji-trukazole",
  "mainVegetable/17": "darzoves/spinatai",
  "mainVegetable/18": "darzoves/fava-pupeles",
  "mainVegetable/19": "darzoves/flageolet-pupeles",
  "mainVegetable/20": "darzoves/ploksciosios-pupeles",
  "mainVegetable/21": "darzoves/liofilizuotos-pupeles",
  "mainVegetable/22": "darzoves/zaliosiosios-pupeles",
  "mainVegetable/23": "darzoves/lesiai",
  "mainVegetable/24": "darzoves/darzoviu-misinys",
  "mainVegetable/25": "darzoves/kukuruzai",
  "mainVegetable/26": "darzoves/salotu-misiniai",
  "mainVegetable/27": "darzoves/rope",
  "mainVegetable/28": "darzoves/svogunas",
  "mainVegetable/29": "darzoves/sojos-pupeles",
  "mainVegetable/30": "darzoves/paprikos",
  "mainVegetable/31": "darzoves/bulves",
  "mainVegetable/32": "darzoves/sojos-pupeliu-daigai",
  "mainVegetable/33": "darzoves/ridikeliai",
  "mainVegetable/34": "darzoves/azuolo-lapu-salotos",
  "mainVegetable/35": "darzoves/frisee-salotos",
  "mainVegetable/36": "darzoves/iceberg-salotos",
  "mainVegetable/37": "darzoves/piedmontese-salotos",
  "mainVegetable/38": "darzoves/ryziu-salotos",
  "mainVegetable/39": "darzoves/romanines-salotos",
  "mainVegetable/40": "darzoves/ugliai",
  "mainVegetable/41": "darzoves/salotos",
  "mainVegetable/42": "darzoves/lamb-salotos",
  "mainVegetable/43": "darzoves/grazgarste",
  "mainVegetable/44": "darzoves/pastarnokai",
  "mainVegetable/45": "darzoves/taboule",
  "mainVegetable/46": "darzoves/pomidorai",
  "mainVegetable/47": "darzoves/sviestines-pupeles",
  "mainVegetable/48": "darzoves/avinzirniai",
  "mainVegetable/49": "darzoves/porai",
  "mainVegetable/50": "darzoves/moliugas",
  "mainVegetable/51": "darzoves/raudonosios-pupeles",
  "mainVegetable/52": "darzoves/obuoliai",
  "mainVegetable/53": "darzoves/kastonai",
  "mainVegetable/54": "darzoves/slyvos",
  "mainVegetable/55": "darzoves/gardener",
  "mainVegetable/56": "darzoves/juodosios-alyvuoges",
  "mainVegetable/57": "darzoves/artisokai",
  "mainVegetable/58": "darzoves/raudonoji-paprika",
  "mainVegetable/59": "darzoves/zaliosios-sparagines-pupeles",
  "mainVegetable/60": "darzoves/spring",
  "mainVegetable/61": "darzoves/troskinys",
  "mainVegetable/62": "darzoves/kuskusas",
  "mainVegetable/63": "darzoves/tagine",
  "mainVegetable/64": "darzoves/curry-vegetables",
  "mainVegetable/65": "darzoves/pea-cups",
  "mainVegetable/66": "darzoves",
  "mainVegetable/67": "darzoves/koraliniai-lesiai",
  "mainVegetable/68": "darzoves/bolivine-balanda",
  "mainVegetable/69": "darzoves/spelta",
  "mainVegetable/70": "darzoves/bulguras",
  "mainVegetable/71": "darzoves/raudonasis-kopustas",
  "mainVegetable/72": "darzoves/lapinis-kopustas",
  "mainVegetable/73": "darzoves/petrazole",
  "mainVegetable/74": "darzoves/kruopos-ir-seklos",
  "mainVegetable/75": "darzoves/darzoves",
  "mainVegetable/76": "darzoves/saldziosios-bulves",
  "mainVegetable/77": "darzoves/moliugas",
  "mainVegetable/78": "darzoves/tesla",
  "mainVegetable/79": "darzoves/pupeles",
  "mainVegetable/80": "darzoves/zirneliai-morkos",
  "mainVegetable/81": "darzoves/zirneliai",
  "mainVegetable/82": "darzoves/edamame-pupeles",
  "mainVegetable/83": "darzoves/mieziai",
  "mainVegetable/84": "darzoves/salotu-misinys",
  "mainVegetable/85": "darzoves/sugar-loaf-chicory",
  "mainVegetable/86": "darzoves/lamb-lettuce",
  "mainVegetable/87": "darzoves/spinatai",
  "mainVegetable/88": "darzoves/baby-green-batavia",
  "mainVegetable/89": "darzoves/swiss-chard",
  "mainVegetable/90": "darzoves",
  "mainVegetable/91": "darzoves",
  "mainVegetable/92": "darzoves",
  "mainVegetable/93": "darzoves",
  "mainVegetable/94": "darzoves",
  "mainVegetable/95": "darzoves",
  "mainVegetable/96": "darzoves",
  "mainVegetable/97": "darzoves",
  "mainVegetable/98": "darzoves",
  "season": "sezonai",
  "season/1": "sezonai/vasara",
  "season/2": "sezonai/ruduo",
  "season/3": "sezonai/ziema",
  "season/4": "sezonai/pavasaris",
  "season/5": "sezonai",
  "technologie": "pagaminimo-budas",
  "technologie/AC01": "pagaminimo-budas/konservuotas",
  "technologie/AD01": "pagaminimo-budas/saldytas",
  "technologie/AG01": "pagaminimo-budas/sviezias",
  "technologie/AT01": "pagaminimo-budas/caterer",
  "recipeDish": "patiekalas",
  "recipeDish/ACC": "patiekalas/garnyras",
  "recipeDish/APE": "patiekalas/garnyras",
  "recipeDish/DES": "patiekalas/desertas",
  "recipeDish/ENT": "patiekalas/uzkandis",
  "recipeDish/PLAT": "patiekalas/pagrindinis-patiekalas",
  "recipeDish/SAL": "patiekalas/salotos",
  "recipeDish/SNA": "patiekalas/uzkandis",
  "recipeDish/PDE": "patiekalas/pusryciai",
  "recipeDish/DEJ": "patiekalas/pietus",
  "recipeDish/TRA": "patiekalas/tradiciniai",
  "recipeDish/GOU": "patiekalas/gurmaniskas-uzkandis",
  "recipeDish/ETH": "patiekalas/tradiciniai",
  "recipeDish/FCH": "patiekalas/vaikams",
  "recipeDish/SOU": "patiekalas/sriubos",
  "pred-recipeTimingCook-facet": "kepimo-laikas",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "kepimo-laikas/0-15-minuciu",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "kepimo-laikas/15-30-minuciu",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "kepimo-laikas/30-45-minuciu",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "kepimo-laikas/45-minuciu",
  "pred-recipeTimingPreparation-facet": "paruosimo-laikas",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "paruosimo-laikas/0-15-minuciu",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "paruosimo-laikas/15-30-minuciu",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "paruosimo-laikas/30-45-minuciu",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "paruosimo-laikas/45-minuciu",
  "pred-recipeCost-Facet": "kaina",
  "pred-recipeCost-Facet/petit": "kaina/pigus",
  "pred-recipeCost-Facet/moyen": "kaina/vidutinio-brangumo",
  "pred-recipeCost-Facet/grand": "kaina/brangus",
  "recipeDifficulty": "paruosimas",
  "recipeDifficulty/1": "paruosimas/lengvas",
  "recipeDifficulty/2": "paruosimas/vidutinio-sunkumo",
  "recipeDifficulty/3": "paruosimas/sudetingas",
  "recipeDishNumber": "porciju-skaicius",
  "recipeDishNumber/1": "porciju-skaicius/1",
  "recipeDishNumber/2": "porciju-skaicius/2",
  "recipeDishNumber/3": "porciju-skaicius/3",
  "recipeDishNumber/4": "porciju-skaicius/4",
  "recipeDishNumber/5": "porciju-skaicius/5",
  "recipeDishNumber/6": "porciju-skaicius/6",
  "recipeDishNumber/7": "porciju-skaicius/7",
  "recipeDishNumber/8": "porciju-skaicius/8",
  "productTheme": "produkto-tema",
  "productTheme/ACC": "produkto-tema/garnyras",
  "productTheme/BEA": "produkto-tema/pupeles",
  "productTheme/BIS": "produkto-tema/pupeles-padaze",
  "productTheme/BIO": "produkto-tema/eko",
  "productTheme/CAN": "produkto-tema/konservuotas",
  "productTheme/CER": "produkto-tema",
  "productTheme/CLS": "produkto-tema/klasikinis",
  "productTheme/DLE": "produkto-tema/darzoves",
  "productTheme/EDR": "produkto-tema/patiekalu-draugas",
  "productTheme/ENT": "produkto-tema/uzkandis",
  "productTheme/FRZ": "produkto-tema/saldytas",
  "productTheme/FSD": "produkto-tema/salotu-misinys",
  "productTheme/FSH": "produkto-tema/kaina",
  "productTheme/ING": "produkto-tema/ingredientai-mano-receptui",
  "productTheme/JAR": "produkto-tema/darzoves-stiklainyje",
  "productTheme/LBW": "produkto-tema",
  "productTheme/LDF": "produkto-tema/darzoves-kepimui",
  "productTheme/LEG": "produkto-tema",
  "productTheme/LGO": "produkto-tema/darzoves",
  "productTheme/LGR": "produkto-tema/grilintos-darzoves",
  "productTheme/LGS": "produkto-tema",
  "productTheme/MAI": "produkto-tema/majonezas",
  "productTheme/MUS": "produkto-tema/pievagrybiai",
  "productTheme/NEW": "produkto-tema/naujienos",
  "productTheme/PDH": "produkto-tema/dry-vegetable-kitchen-dishes",
  "productTheme/PDL": "produkto-tema/basket-of-vegetables",
  "productTheme/PHR": "produkto-tema/pasta-and-pasta",
  "productTheme/PLP": "produkto-tema/pagrindiniams-patiekalams",
  "productTheme/RAL": "produkto-tema/ryziu-darzoves",
  "productTheme/RDM": "produkto-tema/patiekalas",
  "productTheme/SAL": "produkto-tema/viskas-mano-salotoms",
  "productTheme/SDB": "produkto-tema/salotos-patiekalams",
  "productTheme/SNK": "produkto-tema/uzkandziai",
  "productTheme/SUP": "produkto-tema/sriubos",
  "productTheme/TEX": "produkto-tema/tex-mex",
  "productTheme/VGP": "produkto-tema/darzoviu-baltymai",
  "recipeTheme": "receptu-tema",
  "recipeTheme/01": "receptu-tema/vakareliu-patiekalai",
  "recipeTheme/02": "receptu-tema/uzkandziai",
  "recipeTheme/03": "receptu-tema/salotos-ir-uzkandziai",
  "recipeTheme/04": "receptu-tema/sriubos",
  "recipeTheme/05": "receptu-tema/pyragai",
  "recipeTheme/06": "receptu-tema/vaikams",
  "recipeTheme/07": "receptu-tema/desertai",
  "recipeTheme/08": "receptu-tema/vegetariski",
  "recipeTheme/09": "receptu-tema/priedai",
  "recipeTheme/10": "receptu-tema/issinesimui",
  "recipeTheme/11": "receptu-tema/mijotes",
  "recipeTheme/12": "receptu-tema/salotos-ir-barbeque",
  "recipeTheme/13": "receptu-tema/salotos-ir-uzkandziai",
  "recipeTheme/14": "receptu-tema/pagrindiniai-patiekalai",
  "recipeTheme/15": "receptu-tema/desertai-ir-pyragaiciai",
  "recipeTheme/16": "receptu-tema/uzkandziai-ir-sriubos",
  "recipeTheme/17": "receptu-tema/salotos",
  "recipeTheme/18": "receptu-tema/dubenelis",
  "recipeTheme/19": "receptu-tema/sriuba",
  "recipeTheme/20": "receptu-tema/uzkandis",
  "recipeTheme/21": "receptu-tema/padazas",
  "recipeTheme/22": "receptu-tema/vienas-patiekalas",
  "recipeTheme/23": "receptu-tema/kiti-patiekalai",
  "recipeTheme/24": "receptu-tema/patiekalas-keturiems",
  "recipeTheme/25": "receptu-tema",
  "recipeTheme/26": "receptu-tema",
  "recipeTheme/27": "receptu-tema",
  "recipeTheme/28": "receptu-tema",
  "recipeTheme/33": "receptu-tema",
  "recipeTheme/34": "receptu-tema",
  "recipeTheme/35": "receptu-tema",
  "recipeTheme/36": "receptu-tema",
  "recipeTheme/37": "receptu-tema",
  "recipeTheme/38": "receptu-tema",
  "recipeTheme/39": "receptu-tema",
  "recipeTheme/40": "receptu-tema",
  "recipeTheme/41": "receptu-tema",
  "recipeTheme/42": "receptu-tema",
  "recipeTheme/43": "receptu-tema",
  "recipeTheme/44": "receptu-tema",
  "recipeTheme/45": "receptu-tema",
  "recipeTheme/46": "receptu-tema",
  "pred-particularite": "maisto-specifika",
  "pred-particularite/Sans%20conservateur": "maisto-privalumai/be-konservantu",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "maisto-privalumai",
  "pred-particularite/Sans%20colorant": "maisto-privalumai/be-dazikliu",
  "pred-particularite/Sans%20sucre%20ajout%E9": "maisto-privalumai/be-pridetinio-cukraus",
  "pred-particularite/Sans%20sel%20ajout%E9": "maisto-privalumai/be-pridetines-druskos",
  "pred-particularite/Sans%20additif": "maisto-privalumai/be-priedu",
  "pred-particularite/": "maisto-privalumai/be-pridetines-druskos",
  "pred-particularite/Sans%20lactose": "maisto-privalumai/be-laktoze",
  "pred-particularite/Sans%20gluten": "maisto-privalumai/be-glitimas",
  "pred-particularite/V%E9g%E9tarien": "maisto-privalumai/vegetariskas",
  "pred-particularite/V%E9g%E9talien": "maisto-privalumai/veganiskas",
  "pred-particularite/Sans%20sulfite": "maisto-privalumai",
  "pred-particularite/A%20la%20vapeur": "maisto-privalumai",
  "pred-particularite/Sans%20condiment": "maisto-privalumai",
  "cultureType": "kulturos-tipas",
  "cultureType/Bio": "kulturos-tipas/eko",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "kulturos-tipas/be-pesticidu",
  "cultureType/Sans%20OGM": "kulturos-tipas/be-gmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "maisto-specifika/veganiskas",
  "pred-particularite/recipeVeggie": "maisto-specifika/vegetariskas",
  "pred-particularite/recipeGlutenfree": "maisto-specifika/be-glitimo",
  "pred-particularite/recipeLactosefree": "maisto-specifika/be-laktozes"
};
